import { FCC } from "types";

export const TextContainer: FCC = ({ children }) => (
  <p className="h-7 text-lg font-semibold text-primary-100">
    {children || "-"}
  </p>
);
